import Vue from 'vue'
import Vuex from 'vuex'
import { modules } from './modules'

Vue.use(Vuex)

export let store = new Vuex.Store({ modules })
